var modules_28f16a69 = {"avatar":"_1emgzro","size-16":"_xd4do1","size-20":"_1o5dliy","group":"_m7dqpw"};
import "../../../assets/Dq8-Tq8b.css";

export { modules_28f16a69 as default };
//# sourceMappingURL=Avatar.module.less.js.map
